<template>
    <custom-tooltip :tooltipProps="{ left: true, color: colors.tooltip }" v-if="state.isFamily || state.isContributor">
        <template v-slot:activator>
            <v-chip 
                :color="colors.bg" 
                :text-color="colors.text"
            >
                <v-icon v-if="limitReached" class="mr-1">
                    mdi-alert
                </v-icon>
                <div>
                    {{ computedTotal }} 
                    / 
                    {{ maxItems }}
                </div>
            </v-chip>
        </template>

        <template v-slot:content>
            <span>{{ computedTooltip }}</span>
        </template>
    </custom-tooltip>
</template>

<script>
import CustomTooltip from '@/components/ui/CustomTooltip.vue';

export default {
    inject: ['state'],
    components: {
        CustomTooltip,
    },
    props: {
        uploadsCount: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        tributeVideo() {
            return this.$store.state.tributeVideo;
        },
        colors() {
            const currentLevel = this.limitPercentage;

            // yellow at 80 percent
            if (currentLevel < 80) {
                return {
                    bg: '#cecece',
                    text: '#333',
                    tooltip: ''
                }
            } else if (currentLevel >= 80 && currentLevel < 100) {
                return {
                    bg: '#ffd5b2',
                    text: '#a41515',
                    tooltip: 'warning'
                }
            }
            return {
                bg: '#e23030',
                text: '#fff',
                tooltip: 'error'
            }
            // red once max is reached
        },
        limitPercentage() {
            return Math.round((this.computedTotal / this.maxItems) * 100);
        },
        computedTooltip() {
            if (this.limitReached) {
                return `You've reached your upload limit.`
            }
            if (this.state.isContributor && this.tributeVideo?.maxSessionItems) {
                return `You have ${this.maxItems - this.uploadsCount} uploads left.`;
            }

            return `You have used ${ this.limitPercentage}% of your uploads.`
        },
        limitReached() {
            return this.computedTotal >= this.maxItems;
        },
        maxItems() {
            if (this.state.isContributor && this.tributeVideo.maxSessionItems) {
                return this.tributeVideo.maxSessionItems;
            }
            return this.tributeVideo.maxItems;
        },
        computedTotal() {

            if (this.state.isContributor && this.tributeVideo.maxSessionItems) {
                return this.$props.uploadsCount;
            }
            return this.tributeVideo.totalSlidesCount || this.tributeVideo.totalPhotos;
        }
    }
}
</script>

<style lang="scss" scoped>

</style>